import * as logger from "../utils/logger";
import { dispatcher, DispatcherEvents } from "../utils/dispatcher";
import { getCurrentVehicle, isNoVehicle } from "../utils/device";
import { BaseCache, makeDeviceCache } from "../utils/storage/cache";
import { Device } from "../model/Device";
import { getServerDate } from "../utils/storage/date";
import constants from "../constants";
import Api from "./api";
import { DriveStore } from "../store/reducers";
import { MobileActions } from "../store/mobile/actions";
import { DataActions } from "../store/data/actions";
import { NetworkStates } from "../store/mobile/types";

export default class Network {
    private readonly api: Api;
    private readonly store: DriveStore;
    private readonly deviceCache: BaseCache<IDevice | Device>;

    constructor(api: Api, store: DriveStore) {
        this.api = api;
        this.store = store;
        this.deviceCache = makeDeviceCache(this.store);
    }

    checkBridge() {
        let attachedDevice = getCurrentVehicle();
        let apiUser = this.api.getUser();
        let updateStatus = (online: boolean | undefined, deviceCommunicating: boolean) => {
            // Skip logging and events if nothing changed
            let isCurrentlyOnline = this.store.getState().mobile.online === NetworkStates.ONLINE;
            if (isCurrentlyOnline === online && this.store.getState().mobile.deviceCommunicating === deviceCommunicating) {
                return;
            }
            logger.log(logger.Source.SERVICES, ["Network? " + (online ? "Online" : "Offline"), "Device Communicating? " + (deviceCommunicating ? "Yes" : "No")], apiUser);

            dispatcher.trigger(DispatcherEvents.StatusOnline, online);
            this.store.dispatch(MobileActions.setDeviceCommunicating(deviceCommunicating));
        };

        if (attachedDevice !== null && !isNoVehicle()) {
            this.deviceCache.getOrFetch(this.api, { id: attachedDevice.id }).then(devices => {
                let currentAttachedDevice = new Device(devices && devices[0] && devices[0][0]);
                this.api.call("Get", {
                    typeName: "DeviceStatusInfo",
                    search: {
                        deviceSearch: { id: (attachedDevice as any).id }
                    },
                    propertySelector: {
                        fields: ["isDeviceCommunicating", "dateTime", "latitude", "longitude"],
                        isIncluded: true
                    }
                }, data => {
                    let info: IDeviceStatusInfo | undefined = data ? data[0] : undefined;
                    let isDeviceCommunicating = !!(info && info.isDeviceCommunicating);
                    info && this.store.dispatch(MobileActions.setLastDeviceCommunicationDateTime(info.dateTime));

                    if (!isDeviceCommunicating && currentAttachedDevice && currentAttachedDevice.activeFrom) {
                        // Give the device 15 minutes to *start* communicating if it was recently added (like via a rental)
                        isDeviceCommunicating = getServerDate().getTime() - currentAttachedDevice.activeFrom.getTime() < constants.DEVICE_COMMUNICATING_GRACE_PERIOD_MS;
                    }

                    if (isDeviceCommunicating && info && info.latitude && info.longitude && !this.store.getState().data.driving) {
                        this.store.dispatch(DataActions.setVehicleLocation({ x: info.longitude, y: info.latitude }));
                    } else {
                        this.store.dispatch(DataActions.setVehicleLocation(undefined));
                    }

                    updateStatus(true, isDeviceCommunicating);
                }, () => {
                    // Callback error, likely due to being offline, could not determine if telematics device was communicating or not
                    this.store.dispatch(DataActions.setVehicleLocation(undefined));
                    updateStatus(false, true);
                });
            }).catch(() => {
                // Callback error
                updateStatus(false, false);
            });
        }
    }

    destroy() {
    }
}
